import { useContext, useEffect } from 'react';
import { BOTTOM_LAYER_ABOVE_SATELLITE } from '../../constants/map';
import { MapContext } from '../../contexts/MapContext';
import { baseLayerTypes } from '../../hooks/useBaseLayer';
import { AzureMapAttribution } from '../AzureMapAttribution';
import { useUserRole } from '../../utils/hooks';

export const AZURE_LAYER_ID = 'azure-satellite-layer';
const AZURE_SOURCE_ID = 'azure-satellite';

const AzureLayer = ({ map }) => {
  const {
    baseMapState: { baseLayer },
  } = useContext(MapContext);
  const { isAuthenticated } = useUserRole();
  // Only show the attribution when this layer is enabled.
  const showAttribution = baseLayer === baseLayerTypes.AZURE_SATELLITE;
  const tileApi = `${
    isAuthenticated ? '' : '/api/public'
  }/azure-tiles/{z}/{x}/{y}`;

  useEffect(() => {
    map.addSource(AZURE_SOURCE_ID, {
      type: 'raster',
      tiles: [tileApi],
      tileSize: 256,
      minZoom: 1,
      maxZoom: 19,
    });
    map.addLayer(
      {
        id: AZURE_LAYER_ID,
        source: AZURE_SOURCE_ID,
        type: 'raster',
        minZoom: 12,
      },
      BOTTOM_LAYER_ABOVE_SATELLITE,
    );

    return () => {
      // eslint-disable-next-line no-underscore-dangle
      if (map && !map._removed) {
        map.removeLayer(AZURE_LAYER_ID);
        map.removeSource(AZURE_SOURCE_ID);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return showAttribution ? <AzureMapAttribution map={map} /> : null;
};

export default AzureLayer;
